import { Box, Dialog, Modal } from "@mui/material";
import { LoginHistory } from "../openApi/api";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { getFormattedDateTime } from "../common/helper";

type Props = {
  open: boolean;
  handleOpen: (open: boolean) => void;
  loginHistory: LoginHistory[];
};

export const LoginHistoryModal = ({
  open,
  handleOpen,
  loginHistory,
}: Props) => {
  return (
    <Dialog open={open} onClose={() => handleOpen(false)} fullWidth>
      <Box
        className="modal modal-content"
        sx={{ borderRadius: "5px !important" }}
      >
        <Box className="modal-header border-0 pb-0">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => handleOpen(false)}
          ></button>
        </Box>
        <Box className="modal-body">
          <Box className="text-center mb-5">
            <h6 className="modal-title fs-5">Login History</h6>
            <p className="text-muted">
              Showing last {loginHistory.length} login history
            </p>
          </Box>
          <ul className="list-group">
            {loginHistory.map((history, index) => {
              const txDatetime = new Date(history.loggedIn);
              const now = Date.now();
              const offset = now - txDatetime.getTime();

              let agoString = "";
              if (offset <= 5 * 1000) {
                agoString = "Just now";
              } else if (offset < 60 * 1000) {
                agoString = Math.floor(offset / 1000) + " seconds ago";
              } else if (offset < 3600 * 1000) {
                agoString = Math.floor(offset / (60 * 1000)) + " minutes ago";
              } else if (offset < 24 * 3600 * 1000) {
                agoString = Math.floor(offset / (3600 * 1000)) + " hours ago";
              } else if (offset < 2 * 24 * 3600 * 1000) {
                agoString = "A day ago";
              } else {
                agoString =
                  Math.floor(offset / (3600 * 1000 * 24)) + " days ago";
              }
              return (
                <li
                  key={index}
                  className="list-group-item d-flex align-items-baseline gap-2 p-3"
                >
                  <AccessTimeOutlinedIcon className="text-icon me-1" />
                  <Box>
                    <Box>{getFormattedDateTime(history.loggedIn)}</Box>
                    <span className="small text-muted">{agoString}</span>
                  </Box>
                </li>
              );
            })}
          </ul>
        </Box>
      </Box>
    </Dialog>
  );
};
